import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import {take} from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {ApiService} from '@app/services/api/api.service';
import {AuthService} from '@app/services/auth/auth.service';
import {Logger} from '@app/services/logger/logger.service';
import { ProfileService } from '@app/services/profile/profile.service'

import {getAgeAtDate} from '@app/utils';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { LazyBsDatepickerModule } from '@app/utils/forLazyRoot';

@Component({
  selector: 'app-symptom-survey-modal',
  templateUrl: './symptom-survey-modal.component.html',
  styleUrls: ['./symptom-survey-modal.component.scss'],
})
export class SymptomSurveyModalComponent implements OnInit {
  minDate = new Date('2020-01-01');
  today = new Date();
  profileModel: any;
  zip: string;

  symptoms = [
    'fever',
    'dry_cough',
    'wet_cough',
    'sore_throat',
    'runny_nose',
    'muscle_or_body_aches',
    'headaches',
    'fatigue',
    'vomiting',
    'diarrhea',
    'loss_of_smell',
    'loss_of_taste',
    'tight_chest',
    'out_of_breath',
    'rash',
    'conjunctivitis',
    'loss_of_speech_or_movement',
    'discoloration_of_fingers_or_toes'
  ];

  constructor(public modal: NgbActiveModal, private api: ApiService, private auth: AuthService,
              private logger: Logger, public profile: ProfileService) { }

  ngOnInit(): void {
    this.profileModel = this.profile.getValue();
    this.zip = this.profileModel.addresses?.[0]?.postal || '';
  }

  onSubmit(form: NgForm) {
    Object.values(form.controls).forEach(control => control.markAsDirty());
    if (!form.valid) { return; }

    const { start_date, end_date, zip, ...symptomsObj } = form.value;
    const { birth_date, addresses } = this.profileModel;
    const symptoms = Object.entries(symptomsObj)
      .filter(([_, selected]) => selected)
      .map(([symptom]) => symptom.replace(/ /g, '_'));

    const data = {
      start_date: start_date?.toISOString?.().split('T')[0] || null,
      end_date: end_date?.toISOString?.().split('T')[0] || null,
      symptoms,
      age: getAgeAtDate(birth_date, this.today),
      zip: zip || addresses?.[0]?.postal
    };

    // TODO: send data, check if email has been used and ZIP code is valid, show respective response
    this.api.saveSurveyStatus(data).pipe(take(1)).subscribe(response => {
      localStorage.setItem('symptomSurveyCompleted', '1');
      this.modal.close();
      this.logger.showAlert({
        translate: 'symptomsSuccess',
        type: 'success',
        iconHtml: '<img src="../assets/img/patientlynk/SVG/thumb.svg" style="position: absolute; left: 0" />'
      });
    }, serverError => this.logger.showAlert(serverError));
  }
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslocoModule,
    LazyBsDatepickerModule
  ],
  declarations: [SymptomSurveyModalComponent],
  exports: [SymptomSurveyModalComponent]
})
export class SymptomSurveyModalComponentModule {}
